export default function ColorPickerField({ label, value, onChange }) {
  return (
    <div className="flex items-center justify-between">
      <span className="text-xs text-slate-600 dark:text-gray-300">{label}</span>
      <div className="flex items-center gap-2">
        <input
          type="color"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-7 h-7 p-0 border-0 rounded cursor-pointer bg-transparent"
        />
        <span className="text-[10px] font-mono text-slate-400 dark:text-gray-500 w-16 text-right uppercase">
          {value}
        </span>
      </div>
    </div>
  )
}
